import { companyConstants } from "../../_constants";
import axiosInstance from "../../../_helpers/axiosInstance";
import config from "../../../_config/config";

// create job
export const create_company_hiring_manager_action =
  (data) => async (dispatch) => {
    dispatch({
      type: companyConstants.CREATE_COMPANY_HIRING_MANAGER_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.post(
        config.company.createCompany,
        data
      );
      if (response.status) {
        dispatch({
          type: companyConstants.CREATE_COMPANY_HIRING_MANAGER_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: companyConstants.CREATE_COMPANY_HIRING_MANAGER_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

// create job
export const get_company_details_hiring_manager_action =
  (id) => async (dispatch) => {
    dispatch({
      type: companyConstants.GET_COMPANY_DETAILS_HIRING_MANAGER_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        config.company.companyDetails.replace(':id', id)
      );
      if (response.status) {
        dispatch({
          type: companyConstants.GET_COMPANY_DETAILS_HIRING_MANAGER_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: companyConstants.GET_COMPANY_DETAILS_HIRING_MANAGER_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

  // create job
export const update_company_details_hiring_manager_action =
(id,data) => async (dispatch) => {
  dispatch({
    type: companyConstants.UPDATE_COMPANY_DETAILS_HIRING_MANAGER_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.put(
      config.company.companyDetails.replace(":id", id), data
    );
    if (response.status) {
      dispatch({
        type: companyConstants.UPDATE_COMPANY_DETAILS_HIRING_MANAGER_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: companyConstants.UPDATE_COMPANY_DETAILS_HIRING_MANAGER_ACTION_FAILURE,
      payload: e.msg,
    });
  }
};
